import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class ReportYearAudit extends BaseDangerDetail {
    constructor(props) {
        super(props);
    }

    getColumns = () => {
        let column = [{
            title: '审计意见类型',
            dataIndex: 'Audopiniondom',
            width: 160
        }, {
            title: '结果说明',
            dataIndex: 'Auditopin'
        }, {
            title: '审计机构',
            dataIndex: 'Auditcompdom',
            width: 260
        }];
        return column;
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/ReportYearAudit.jsx